<template src="./template.html"></template>
<script>
import analyticsLib from 'lib/analytics'

export default {
  name: 'app',
  data() {
    return {}
  },
  watch: {
    $route() {
      analyticsLib.pageView()
    },
  },
  mounted() {
    analyticsLib.pageView()

    this.$store.dispatch('getCurrentUser')
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/App/index.vue